var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{class:_vm.compClasses,on:{"click":_vm.reveal}},[_c('span',{staticClass:"agent-card__word"},[_vm._v(_vm._s(_vm.card.word))])])])}
var staticRenderFns = []

export { render, staticRenderFns }